module.exports = __webpack_public_path__ + "img/pr-1.5e4ac9b4.png";